import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { hasRole, INTERNAL_ROLES } from "@/lib/roles";
import { toast } from "sonner";

const IDLE_MS = 30 * 60 * 1000;
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

/** A6: automatic logout after 30 minutes of inactivity (internal roles). */
export default function IdleLogout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const internal = hasRole(user, ...INTERNAL_ROLES);

  useEffect(() => {
    if (!internal) return undefined;
    let timer;
    const expire = async () => {
      await logout();
      toast.info("Sessione scaduta per inattività: effettua di nuovo l'accesso");
      navigate("/login");
    };
    const reset = () => { clearTimeout(timer); timer = setTimeout(expire, IDLE_MS); };
    EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => { clearTimeout(timer); EVENTS.forEach((e) => window.removeEventListener(e, reset)); };
  }, [internal, logout, navigate]);

  return null;
}
